import VueRouter from 'vue-router'
import Home from '../pages/home'
import Recommend from '../pages/recommend'
import Follow from '../pages/follow'
import Mine from '../pages/mine'
import store from '@/store'
import { getToken } from '@/api/auth'
import Login from '@/pages/login'

const routes = [
    {
        path: '/',
        redirect: '/home'  // 添加根路径重定向
    },
    {
        // 首页
        path: '/home',
        component: Home,
        meta: {
            showTabbar: true
        }
    },
    {
        // 这样写好像不行
        // PC端首页
        path: '/index',
        // redirect: '/pc/index.html',
        // component: () => import('@/pages/PC'),
        // meta: {
        //     showTabbar: false
        // }
    },
    {
        // fc3d
        path: '/fc3d',
        component: () => import('@/pages/fc3d'),
        meta: {
            showTabbar: true
        }
    },
    {
        // pl3
        path: '/pl3',
        component: () => import('@/pages/pl3'),
        meta: {
            showTabbar: true
        }
    },
    {
        // 排行榜
        path: '/charts',
        component: () => import('@/pages/charts/index.vue'),
        meta: {
            showTabbar: true
        }
    },
    {
        // 专家主页
        path: '/mavin',
        component: () => import('@/pages/mavin'),
        meta: {
            showTabbar: false
        }
    },
    {
        // 帖子详情页
        path: '/detail',
        component: () => import('@/pages/postdetail'),
        meta: {
            showTabbar: false
        }
    },
    {
        // 推荐页
        path: '/recommend',
        component: Recommend,
        meta: {
            showTabbar: true
        }
    },
    {
        // 关注页
        path: '/follow',
        component: Follow,
        meta: {
            showTabbar: true, // 是否显示底部导航
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 我的页
        path: '/mine',
        component: Mine,
        meta: {
            showTabbar: true
        }
    },
    {
        // 资料编辑页
        name: 'UserEdit',
        path: '/useredit',
        component: () => import('@/pages/mine/userEdit.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 登录页
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        // 注册页
        path: '/register',
        name: 'Register',
        component: () => import('@/pages/register/index.vue')
    },
    {
        // 我的帖子
        path: '/mypost',
        name: 'MyPost',
        component: () => import('@/pages/mine/myPost.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 我的评论
        path: '/myremark',
        name: 'MyRemark',
        component: () => import('@/pages/mine/myRemark.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 我的收藏
        path: '/collect',
        name: 'Collect',
        component: () => import('@/pages/mine/myCollect.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 我的点赞
        path: '/like',
        name: 'Like',
        component: () => import('@/pages/mine/myLike.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 安全中心
        path: '/security',
        name: 'Security',
        component: () => import('@/pages/mine/usersecurity.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 账户明细
        path: '/account',
        name: 'Account',
        component: () => import('@/pages/mine/account.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 下级管理
        path: '/children',
        name: 'Children',
        component: () => import('@/pages/mine/children.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 下级详情
        path: '/childrenDetail',
        name: 'ChildrenDetail',
        component: () => import('@/pages/mine/childDetail.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 充值页
        path: '/recharge',
        name: 'Recharge',
        component: () => import('@/pages/mine/recharge.vue'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // 客服页
        path: '/custom',
        name: 'Custom',
        component: () => import('@/pages/custom'),
        meta: {
            requiresAuth: true, // 是否需要登录后访问
        }
    },
    {
        // iframe页面
        path: '/iframe',
        name: 'Iframe',
        component: () => import('@/pages/iframePage')
    },
    {
        // 测试
        path: '/test',
        name: 'Test',
        component: () => import('@/pages/test')
    },
    {
        path: '*',
        redirect: '/home'
    }
]

// console.log(VueRouter);
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;

// call与apply：相同点：都可以修改this,
// 不同点：传递的参数，call传递多个参数时，以，作为分隔
// apply传递多个参数时，以数组方式进行


// 重写push/replace
// 第一个参数：告诉原来push方法，你往哪里跳转（传递哪些参数）
// 第二个参数：成功的回调
// 第二个参数：失败的回调
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject);
    } else {
        originPush.call(this, location, () => { }, () => { });
    }
}


VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject);
    } else {
        originReplace.call(this, location, () => { }, () => { });
    }
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果是 keepAlive 且保持滚动的页面，不滚动
        if (to.meta.keepAlive && to.meta.keepScroll) {
            return {}
        }

        // 否则滚动到顶部
        return { x: 0, y: 0 }
    }
})

// ========== 设备检测函数 ==========
function isMobileDevice() {
    // 检测屏幕宽度（最常用，也最准确）
    if (window.innerWidth < 768) return true;
    // 检测User Agent作为补充
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

router.beforeEach((to, from, next) => {

    const isMobile = isMobileDevice()

    // 1. 如果当前是PC设备
    if (!isMobile && !to.path.startsWith('/index')) {
        // // 强制跳转到PC首页（或对应的PC端路由）
        // // 可以保留 query 参数，方便后续使用
        // return next({ path: '/index', query: to.query })
        window.location.href = '/pc/index.html'
    }







    // 避免循环重定向
    if (to.path === from.path) {
        // next()
        return
    }

    const hasToken = getToken()
    const requiresAuth = to.matched.some(r => r.meta.requiresAuth)

    // 登录页特殊处理
    if (to.path === '/login') {
        if (hasToken) {
            // 如果已经登录，不允许再去登录页，强行跳转到首页
            next('/home')
        } else {
            next()
        }
        return
    }

    // 需要认证但未登录 → 跳转登录页
    if (requiresAuth && !hasToken) {
        // 记录当前路径，以便登录成功后跳转回来
        store.dispatch('login/setRedirectUrl', to.fullPath)

        console.log(to.fullPath)
        // 跳转到登录页
        next({
            name: 'Login',
            query: { redirectUrl: to.fullPath }
        })
        return
    }

    // 其他所有情况：放行
    next()
})


export default router